import { render, staticRenderFns } from "./RouterLoading.vue?vue&type=template&id=b3a4092e&scoped=true"
import script from "./RouterLoading.vue?vue&type=script&lang=js"
export * from "./RouterLoading.vue?vue&type=script&lang=js"
import style0 from "./RouterLoading.vue?vue&type=style&index=0&id=b3a4092e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a4092e",
  null
  
)

export default component.exports